import { supabase } from "./supabase.js";

/**
 * Calls an Edge Function with the signed-in user's JWT and returns the function's own JSON body even when it
 * answered with an error status (supabase-js hides the body behind error.context in that case), so an admin
 * screen can show "billing_settings_incomplete" rather than "Edge Function returned a non-2xx status code".
 */
export async function callFunction<T = Record<string, unknown>>(
  name: string,
  body: Record<string, unknown> = {}
): Promise<{ ok: true; data: T } | { ok: false; error: string }> {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (!error) return { ok: true, data: data as T };
  try {
    const ctx = (error as { context?: Response }).context;
    const parsed = ctx ? ((await ctx.json()) as { error?: string }) : null;
    if (parsed?.error) return { ok: false, error: parsed.error };
  } catch {
    // fall through to the generic message
  }
  return { ok: false, error: error.message };
}
